/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import clsx from 'clsx'
import {useLayout} from '../core'
//Redux ToolKit API
import {useCompanyQuery, useUpdateCompanyMutation} from '../../../app/api/endpoints/company'

//i18n - react-intl - internationalization - locale -localization
import {useIntl} from 'react-intl'

const Footer: FC = () => {
  const {classes} = useLayout()
  const intl = useIntl()

  const {data: companyInformationData} = useCompanyQuery({
    endpointData: {
    },
    toastSuccessMessageStatus: false,
    toastErrorMessageStatus: true,
  })

  const companyInfo = companyInformationData?.data[0]
  
  return (
    <div className={'footer py-4 d-flex flex-lg-column'} id='kt_footer'>
      {/*begin::Container*/}
      <div className={clsx(classes.footerContainer, 'd-flex flex-column flex-md-row flex-stack')}>
        {/*begin::Copyright*/}
        {/* <div className='text-dark order-2 order-md-1'>
          <span className='text-gray-400 fw-bold me-1'>{intl.formatMessage({id: 'FORM.LABEL.COMPANY_NAME'})}</span>
          <a
            href='#'
            className='text-muted text-hover-primary fw-bold me-2 fs-6'
          >
            {companyInfo?.name}
          </a>
        </div> */}
        {/*end::Copyright*/}

        {/*begin::Menu*/}
        {/* <ul className='menu menu-gray-600 menu-hover-primary fw-bold order-1'>
          <li className='menu-item'>
            <a href='https://keenthemes.com/metronic' target='_blank' className='menu-link px-2'>
              About
            </a>
          </li>

          <li className='menu-item'>
            <a href='https://keenthemes.com/metronic' target='_blank' className='menu-link px-2'>
              Support
            </a>
          </li>

          <li className='menu-item'>
            <a href='https://keenthemes.com/metronic' target='_blank' className='menu-link px-2'>
              Purchase
            </a>
          </li>
        </ul> */}
        {/*end::Menu*/}
      </div>
      {/*end::Container*/}
    </div>
  )
}

export {Footer}
